<div class="video-player">
    <video
        (contextmenu)="ignoreVideoClick($event)"
        id="video-player"
        [src]="video"
        [poster]="poster"
        autoplay
        controls
        preload="auto"
        playsinline
        controlsList="nodownload"
        disablePictureInPicture
    >
        <source [src]="video" type="video/mp4">
    </video>
</div>
